// filepath: resources/js/components/pages/CMSPages/FriVia/MyResults/MyQuizAnswersPage.jsx
import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AppBarCMS } from '../../../../basic/index.jsx';
import { Spinner, CollapseBlock } from '../../../../common/index.jsx';
import { useGetAggregatedStudentQuizCorrectAnswersQuery } from '../../../../../redux/services/quiz_student_answers.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient.jsx';
import MyQuizAnswersTable from './MyQuizAnswersTable';

const MyQuizAnswersPage = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('Moje odpovede') + ' - FRI CMS';
  }, [t]);

  // Backend scopes the overview to the authenticated user
  const { data, isLoading } = useGetAggregatedStudentQuizCorrectAnswersQuery(
    {},
  );

  const rows = useMemo(
    () =>
      Array.isArray(data)
        ? data.map((r) => {
            const { children, ...rest } = r;
            return {
              key: r.quiz_id,
              ...rest,
              nested_answers: Array.isArray(children) ? children : [],
            };
          })
        : [],
    [data],
  );

  return (
    <>
      <AppBarCMS
        title={t('Moje odpovede')}
        backUrl={routes.cmsQuizzes}
        backUrlTooltip={t('Kvízy')}
        permissionsBasic={'quiz-student-answers'}
      />
      <div style={{ margin: '10px' }}>
        {isLoading && <Spinner />}
        {!isLoading && (
          <CollapseBlock>
            <MyQuizAnswersTable rows={rows} />
          </CollapseBlock>
        )}
      </div>
    </>
  );
};

export default MyQuizAnswersPage;
